/* eslint-disable @typescript-eslint/no-explicit-any */
import clsx from 'clsx';

import { SerializedStyles } from '@emotion/react';
import BaseComponent from '@tock/shared/components/BaseComponent';
import LoadingComponent from '@tock/shared/components/LoadingComponent';
import ScrollLockComponent from '@tock/shared/components/ScrollLockComponent';

interface Props {
  contentClassName?: string;
  contentCss?: SerializedStyles;
  footer?: any;
  header?: any;
  isLoading?: boolean;
  showOverlay?: boolean;
  scrollContextClassName?: string;
  spinnerText?: string;
}

export default class ClowncarBody extends BaseComponent<React.PropsWithChildren<Props>> {
  clowncarBodyContent: any;

  render() {
    const {
      children,
      contentClassName: contentClassNameFromProps,
      contentCss,
      footer,
      header,
      showOverlay,
      isLoading: isLoadingFromProps,
      scrollContextClassName: scrollContextClassNameFromProps,
      spinnerText,
    } = this.props;

    const isLoading = isLoadingFromProps || false;
    const contentClassName = clsx('ClowncarBody-content', contentClassNameFromProps);
    const scrollContextClassName = clsx(
      'ClowncarBody-scrollContext',
      scrollContextClassNameFromProps,
      {
        'has-footer': footer,
        'has-header': header,
      }
    );

    return (
      <div className="ClowncarBody">
        {header && <header className="ClowncarBody-header">{header}</header>}

        <ScrollLockComponent id="ClowncarBodyContent" className={scrollContextClassName}>
          <LoadingComponent
            css={contentCss}
            containerClassName={contentClassName}
            isLoading={isLoading}
            showOverlay={showOverlay}
            spinnerClassName="ClowncarBody-spinner"
            spinnerText={spinnerText}
          >
            {children}
          </LoadingComponent>
        </ScrollLockComponent>

        {footer && <footer className="ClowncarBody-footer">{footer}</footer>}
      </div>
    );
  }
}
